<template>
  <div class="blur-section">

    <slot name="default"></slot>

    <v-sheet rounded class="text-center upgrade-box px-5"
             :style="style">
      <img src="/security-shield.svg" alt="upgrade" width="150" class="mb-5" />
      <p class="mb-5 call-out">
        {{ calloutMessage }}
      </p>

      <v-btn
        color="primary"
        class="mb-10"
        @click="upgrade"
      >
        {{ $t('common.actions.upgrade') }}
      </v-btn>
    </v-sheet>
  </div>
</template>
<script>

export default {
  name: 'UpgradeCard',
  props: {
    bottom: {
      type: String,
      required: false,
      default: null,
    },
    top: {
      type: String,
      required: false,
      default: null,
    },
    message: {
      type: String,
      required: false,
    },
  },
  computed: {
    style() {
      const newVar = {};

      if (this.bottom) {
        newVar.bottom = `${this.bottom}px`;
      }

      if (this.top) {
        newVar.top = `${this.top}px`;
      }

      return newVar;
    },
    calloutMessage() {
      return this.message ? this.$t(this.message) : this.$t('learn.upgrade_callout');
    },
  },
  methods: {
    upgrade() {
      this.$store.dispatch('dialogs/setPremiumDialog', true);
    },
  },
};
</script>
<style scoped>

.blur-section {
  position: relative;
  min-height: 500px;
}

.blur-section > :not(.upgrade-box) {
  filter: blur(5px);
}

.upgrade-box {
  position: absolute;
  top: 150px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 1;
}

.call-out {
  text-align: center;
  font-family: Unbounded,serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
